import React, { useContext } from "react"
import { AppContext } from "./Context"

export function ObjectPropertyList() {
    const { state, dispatch } = useContext(AppContext)!

    return (
        <div>
            <h1>Object Properties</h1>
            <div>
                {state.objectProperties.map((objectProperty, index) => {
                    return (
                        <div key={objectProperty.name} style={{ border: "2px solid black", padding: "4px", margin: "4px" }}>
                            <h2>Property {objectProperty.name}</h2>
                            <label>Default:</label>
                            <input type="text" value={objectProperty.defaultValue} onChange={e => {
                                const value = parseFloat(e.target.value)
                                if (!isNaN(value)) {
                                    dispatch({
                                        type: "updateObjectProperty",
                                        name: objectProperty.name,
                                        defaultValue: value
                                    })
                                }
                            }} />
                        </div>
                    )
                })}
            </div>
            <input type="button" value="Add" onClick={() => dispatch({ type: "addObjectProperty" })} />
            <input type="button" value="Remove" onClick={() => dispatch({ type: "removeObjectProperty" })} />
        </div>
    )
}